import React, { useState } from 'react';
import useStyles from '../../../../style/js-style/containers/administration/personalization/personalizationStyle';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { TwitterPicker } from 'react-color';
import InputWrapper from './InputWrapper';

const ColorInput = ({ inputItem, disabled }) => {
  const [pickerIsOpen, setPickerIsOpen] = useState(false);
  const { classes } = useStyles();

  const formMethods = useFormContext();
  const {
    control,
    setValue,
    getValues
  } = formMethods;

  const color = useWatch({ control, name: `${inputItem.fieldName}`}) || "#000000";

  const handleColorChange = (color) => {
    if (color){
      setValue(`${inputItem.fieldName}`, color?.hex || "#000")
      setPickerIsOpen(!pickerIsOpen);
    }
  };

  return (
    <InputWrapper inputItem={inputItem}>
      <div style={{ position: 'relative' }}>
        <div
          className={classes.inputItemColorWrapper}
          onClick={() => !disabled && setPickerIsOpen(!pickerIsOpen)}
          style={{ borderColor: color, opacity: disabled ? .5 : 1 }}
        >
          <div className={classes.colorInputColorPart} style={{ backgroundColor: color, opacity: disabled ? .7 : 1 }} />
          <div className={classes.colorPlaceholderContainer}>
            <div className={classes.colorPlaceholder}>
              {inputItem.placeholder}
            </div>
          </div>
        </div>

        {pickerIsOpen && (
          <div className={classes.pickerContainer}>
            <Controller
              control={control}
              name={inputItem.fieldName}
              defaultValue={"#000000"}
              render={({ field }) => (
                <TwitterPicker
                  {...field}
                  color={getValues(inputItem.fieldName)}
                  disabled={disabled}
                  colors={['#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF', '#F2F3F7', '#FFFFFF']}
                  onChangeComplete={handleColorChange}
                />
              )}
            />
          </div>
        )}
      </div>
    </InputWrapper>
  );
}

export default ColorInput;